document.addEventListener("DOMContentLoaded", function () {
  console.log("✅ DOM fully loaded");

  const elementsToAnimate = document.querySelectorAll(".animate-on-scroll");
  console.log("🔍 Found", elementsToAnimate.length, "elements to animate.");

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          console.log("🎯 In view:", entry.target);
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target); // 👈 ensures it only triggers once
        }
      });
    },
    {
      threshold: 0.1,
    }
  );

  elementsToAnimate.forEach(el => {
    observer.observe(el);
  });
});
